import { Typography } from "@mui/material"

export const ValidateErrorMessage = ({ message }) => {
  return (
    <Typography variant="body2" color="error">
      { message }
    </Typography>
  )
}